import React, { useEffect, useState } from "react";
import Button from "../../shared/Button";
import CounterWithlabelin from "../../shared/CounterWithlabelin";
import add from "../../../assets/img/icons/add.svg";
import Textarea from "../../shared/Textarea";
import { useForm } from "react-hook-form";
import { useCreatePlace } from "../../../context/CreatePlaceContext";
import PlaceCapModal from "./Modal/PlaceCapModal";
import { useParams } from "react-router-dom";

const CreateStep4 = ({ prevStep, nextStep }) => {
  const { updatePlaceDetail, createInfoData ,apiUpdateResideces,setIsEditPlaceCompleter} = useCreatePlace();

  const [capacity, setcapacity] = useState(createInfoData.stepFive.capacity);
  const [max_capacity, setmax_capacity] = useState(
    createInfoData.stepFive.max_capacity
  );
  const [max_capacityError, setmax_capacityError] = useState("");
  const [rooms_count, setrooms_count] = useState(
    createInfoData.stepFive.rooms_count
  );
  const [double_bed_count, setdouble_bed_count] = useState(
    createInfoData.stepFive.double_bed_count
  );
  const [single_bed_count, setsingle_bed_count] = useState(
    createInfoData.stepFive.single_bed_count
  );
  const [traditional_bed_count, settraditional_bed_count] = useState(
    createInfoData.stepFive.traditional_bed_count
  );
  const {
    handleSubmit,
    formState: { errors, isValid },
    control,
    reset
  } = useForm({
    defaultValues: {
      sleep_space_description: createInfoData.stepFive.sleep_space_description
    }
  });
  const gotonext = data => {
    if (max_capacity <= capacity) {
      setmax_capacityError("حداکثر ظرفیت باید  بزرگتر از ظرفیت استاندارد باشد");
      window.screenTop(0, 0);
    }else{
       updatePlaceDetail("stepFive", {
      capacity: capacity,
      max_capacity: max_capacity,
      rooms_count: rooms_count,
      double_bed_count: double_bed_count,
      single_bed_count: single_bed_count,
      traditional_bed_count: traditional_bed_count,
      custom_sleep_items: customSleep,
      sleep_space_description: data.sleep_space_description
    });
    nextStep();
    }
   
  };
  const [showaddModal, setshowaddModal] = useState(false);
  const [customSleep, setCustomSleep] = useState(
    createInfoData.stepFive.custom_sleep_items
  );
  useEffect(() => {
    setcapacity(createInfoData.stepFive.capacity)
    setmax_capacity(createInfoData.stepFive.max_capacity)
    setrooms_count(createInfoData.stepFive.rooms_count)
    setdouble_bed_count(createInfoData.stepFive.double_bed_count)
    setsingle_bed_count(createInfoData.stepFive.single_bed_count)
    settraditional_bed_count(createInfoData.stepFive.traditional_bed_count)
    setCustomSleep(createInfoData.stepFive.custom_sleep_items)
  }, [
    createInfoData
  ])
  
  const {id}=useParams()
  const update = (data) => {
    if (max_capacity <= capacity) {
      setmax_capacityError("حداکثر ظرفیت باید  بزرگتر از ظرفیت استاندارد باشد");
      window.screenTop(0, 0);
    }else{
       updatePlaceDetail("stepFive", {
      capacity: capacity,
      max_capacity: max_capacity,
      rooms_count: rooms_count,
      double_bed_count: double_bed_count,
      single_bed_count: single_bed_count,
      traditional_bed_count: traditional_bed_count,
      custom_sleep_items: customSleep,
      sleep_space_description: data.sleep_space_description
    });
       setIsEditPlaceCompleter(true);
    
      }
  };
  return (
    <div className="createsteps CreateStep4">
      <h2>ظرفیت اقامتگاه</h2>
      <p className="w-[100%]">
        ظرفیت اقامتگاه را متناسب با تعداد تخت و امکانات آن در نظر بگیرید. حداکثر
        ظرفیت، مجموع ظرفیت استاندارد و نفرات اضافه است. به مهمان‌های بیشتر از
        ظرفیت استاندارد، نفرات اضافه گفته می‌شود که هزینه‌شان به صورت نفری
        محاسبه خواهد شد.
      </p>
      <div className="createsteps--grid3 mt-[50px]">
        <div>
          <CounterWithlabelin
            label="ظرفیت استاندارد"
            count={capacity}
            setCount={setcapacity}
            labelin="مهمان"
          />
          <span className="input__message text-red mt-[4px]">
            {max_capacityError}
          </span>
        </div>
        <CounterWithlabelin
          label="حداکثر ظرفیت"
          count={max_capacity}
          setCount={setmax_capacity}
          labelin="مهمان"
        />
        <CounterWithlabelin
          label="تعداد اتاق"
          count={rooms_count}
          setCount={setrooms_count}
          labelin="اتاق"
        />
        <CounterWithlabelin
          label="تعداد تخت ۲ نفره"
          count={double_bed_count}
          setCount={setdouble_bed_count}
          labelin="تخت"
        />
        <CounterWithlabelin
          label="تعداد تخت ۱ نفره"
          count={single_bed_count}
          setCount={setsingle_bed_count}
          labelin="تخت"
        />
        <CounterWithlabelin
          label=" تعداد رخت خواب سنتی ( تشک )"
          count={traditional_bed_count}
          setCount={settraditional_bed_count}
          labelin="رخت"
        />
        {customSleep.map(i =>
          <CounterWithlabelin
            label={i.name}
            count={i.count}
            setCount={null}
            labelin="مورد"
          />
        )}
      </div>

      <Button
        varient="borderbot"
        className="mt-[20px]"
        onClick={() => setshowaddModal(true)}
      >
        <div className="flex items-center gap-[5px]">
          <img src={add} />
          <div>افزودن سایر موارد</div>
        </div>
      </Button>
      <div className="createsteps--textarealabel mt-[50px]">
        <h6>توضیحات تکمیلی فضای خواب ( اختیاری ) </h6>
        <p>
          در این قسمت می توانید توضیحات تکمیلی درباره امکانات و شرایط مهیا شده
          برای خواب مهمان ها را ارائه نمایید
        </p>
      </div>
      <div>
        <form >
          <Textarea
            name="sleep_space_description"
            control={control}
            errors={errors}
            className="seconadary-input mt-[8px]"
            rows="5"
          />
          <div className="flex create-box--button justify-end gap-[16px] w-[full] mt-[70px]">
          {id && <Button varient="primary" onClick={handleSubmit((d) =>update(d))}> 
                بروزرسانی اقامتگاه
              </Button>}
            <Button
              varient="gray"
              onClick={() => {
                prevStep();
              }}
            >
              مرحله قبلی
            </Button>

            <Button varient="primary" type="submit" onClick={handleSubmit((d) =>gotonext(d))}>
              مرحله بعدی
            </Button>
          </div>
        </form>
      </div>

      {showaddModal &&
        <PlaceCapModal
          closeModal={() => setshowaddModal(false)}
          setcustomSleep={setCustomSleep}
          customSleep={customSleep}
        />}
    </div>
  );
};

export default CreateStep4;
